import "../components/custom-page-banner-type";

if (document.querySelector(".characteristics__ul")) {
  const tabs = document.querySelectorAll(".characteristics__li");

  tabs.forEach((tab) => {
    let paragraph = tab.querySelector("p");

    tab.addEventListener("click", () => {
      tabs.forEach((otherTab) => {
        let otherParagraph = otherTab.querySelector("p");
        if (otherParagraph !== paragraph) {
          otherParagraph.style.height = "0";
        }
      });

      paragraph.style.height = "auto";
    });
  });
}
if (document.querySelector(".reasons__ul")) {
  const tabs = document.querySelectorAll(".reasons__li");

  tabs.forEach((tab) => {
    let paragraph = tab.querySelector("p");

    tab.addEventListener("click", () => {
      tabs.forEach((otherTab) => {
        let otherParagraph = otherTab.querySelector("p");
        if (otherParagraph !== paragraph) {
          otherParagraph.style.height = "0";
        }
      });

      paragraph.style.height = "auto";
    });
  });
}
